import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation.js";
import {
  BACK_ROW,
  BODY_FONT,
  HEADER_FONT_11,
  HEADER_ROW,
  VALUE_FILL,
  hideColumnsAfter,
  setCell,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  addSheetTitle,
  addTableSpacer,
  applyBorderPattern,
  setupPrinciple2DetailSheet,
  writeDataRow,
} from "./principle2DetailHelpers.js";
import { formatNumber, formatPercent, safeText } from "./principle6SheetHelpers.js";

export const SHEET_NAME = "Details of CSR Project";

const SHEET_TITLE = "Details of beneficiaries of CSR Projects";

const WIDTHS = {
  A: 1.453125,
  B: 1.453125,
  C: 9.1796875,
  D: 7.453125,
  E: 32.54296875,
  F: 32.54296875,
  G: 35.1796875,
  H: 9.1796875,
  I: 1.453125,
  J: 1.453125,
};

const TEMPLATE_ROW = 10;
const SPACER_ROW = 11;
const DATA_START_ROW = 12;
const COL_END = COL_G;
const ALL_THIN = Array(4).fill("tttt");

export function buildDetailsOfCSRProjectSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: false }] });

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd: COL_END,
    ySplit: 11,
    topLeftCell: "D12",
    hiddenCols: ["A", "B"],
  });
  hideColumnsAfter(ws, 8);

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_8, {
    row: BACK_ROW,
    col: COL_END,
    mergeEnd: COL_END,
    align: "right",
    parentCell: "D8",
  });

  addSheetTitle(ws, COL_END, SHEET_TITLE, {
    height: 30,
    borderPatterns: ALL_THIN,
  });

  applyBorderPattern(ws, HEADER_ROW, COL_D, ALL_THIN);
  ws.getRow(HEADER_ROW).height = 29;
  [
    { col: COL_D, label: "Sr.No." },
    { col: COL_E, label: "CSR Project" },
    { col: COL_F, label: "No. of persons benefitted from CSR Projects" },
    {
      col: COL_G,
      label: "% of beneficiaries from vulnerable and marginalized groups",
    },
  ].forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, {
      font: HEADER_FONT_11,
      bold: false,
      bordered: false,
      align: "center",
    });
  });

  applyBorderPattern(ws, TEMPLATE_ROW, COL_D, ALL_THIN);
  for (let col = COL_D; col <= COL_END; col += 1) {
    setCell(ws, TEMPLATE_ROW, col, "", { bordered: false, font: BODY_FONT });
  }
  ws.getRow(TEMPLATE_ROW).hidden = true;

  addTableSpacer(ws, COL_D, COL_END, { row: SPACER_ROW, height: 30, patterns: ALL_THIN });

  const rows = sectionC?.principle8?.leadershipIndicator?.beneficiariesOfCSRProjects || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    writeDataRow(
      ws,
      row,
      COL_D,
      COL_END,
      [
        { col: COL_D, value: idx + 1, align: "center", fill: null, font: BODY_FONT },
        {
          col: COL_E,
          value: safeText(item?.csrProjectName, ""),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_F,
          value: formatNumber(item?.numberOfBeneficiaries),
          align: "center",
          fill: VALUE_FILL,
        },
        {
          col: COL_G,
          value: formatPercent(item?.percentageFromVulnerableMarginalizedGroups),
          align: "center",
          fill: VALUE_FILL,
        },
      ],
      { patterns: ALL_THIN }
    );
  });

  return ws;
}
